import { render, staticRenderFns } from "./ZbarTest.vue?vue&type=template&id=5fa1e6d2&"
import script from "./ZbarTest.vue?vue&type=script&lang=js&"
export * from "./ZbarTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports